import React, { PureComponent } from "react";
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "./PaymentCashCard.css";

class PaymentType extends PureComponent {
  constructor(props) {
    super(props);
    const orderData = this.props.orderData;
    this.state = {
      type: props.payment.type,
      dropDownToggle: false,
      cardTypeToggle: false,
      machineTypeToggle: false,
      amount: props.payment.amount,
    };
    // this.headers = ["CASH", "CARD"];
    this.cardTypes = ["Visa", "Master", "Amex"];
  }

  handleRemove(e) {
    this.props.removePaymentCard(this.props.payment);
    this.props.handleAmount(e);
  }

  componentDidUpdate() {
    let itemToRemoveIndexUpdate
    let duplicateValue
    const currentPaymentType = JSON.parse(localStorage.getItem("propsItem"))
    const removedData = JSON.parse(localStorage.getItem("removedData"))
    const allPayments = JSON.parse(localStorage.getItem("statePayments"))
    const duplicateValuee = allPayments && allPayments.filter(p => p.type === currentPaymentType.type)
    if (duplicateValuee && duplicateValuee.length > 1) {
      duplicateValue = true
    }
    const emptyData = removedData && removedData.type == "" && removedData.amount == "" && removedData.trnsId == "" && removedData.cardType == "" ? true : false
    if (removedData) {
      itemToRemoveIndexUpdate = allPayments.findIndex(p => p.type === removedData.type)
    }

    localStorage.removeItem("duplicate")
    if (duplicateValue && !emptyData && itemToRemoveIndexUpdate == undefined) {
      console.log("going to duplicate 1----> ")
      localStorage.setItem("duplicate", true)
      localStorage.removeItem("noDup")
    }

    if (duplicateValue && !emptyData && itemToRemoveIndexUpdate > -1) {
      console.log("going to duplicate 2----> ")
      localStorage.removeItem("duplicate")
      localStorage.removeItem("noDup")
    }
  }

  render() {
    localStorage.setItem("propsItem", JSON.stringify(this.props.payment))
    const callShippingJobs = JSON.parse(localStorage.getItem("callShippingJobs"));
    const storeCreditLimit = (callShippingJobs[0].data.job.store_credit).toFixed(3);
    const machine_type = callShippingJobs && callShippingJobs[0].data && callShippingJobs[0].data.job.machine_type;
    const machineTypeArray = Object.entries(machine_type).map(([key, value]) => ({
      key,
      label: value
    }));

    return (
      <Row style={{ justifyContent: "center" }}>
        <Col lg={12} xs={10} style={{
          backgroundColor: "#f3efebba",
          borderRadius: "10px",
          margin: "1rem 0rem"
        }}>
          <div className="paymentcashcardsection">
            <button
              className="remove_btn"
              onClick={(e) => this.handleRemove(e)}
            >
              <div className="remove_btn_txt">-</div>
            </button>
            <div className="othercashcard_payment">
              <div className="paymentcashcard_label">Payment Type:</div>
              <Dropdown
                className="paymentTypeDropdownContainer"
                isOpen={this.state.dropDownToggle}
                toggle={() =>
                  this.setState({
                    dropDownToggle: !this.state.dropDownToggle,
                  })
                }
              >
                <DropdownToggle caret className="paymentTypeDropdown">
                  {this.props.payment.type == ""
                    ? "Select"
                    : `${this.props.payment.type}`}
                </DropdownToggle>
                <DropdownMenu className={'dropdownMenu'}>
                  {callShippingJobs && callShippingJobs[0].data.job.payment_types.map((type, i) => (
                    <DropdownItem
                      key={i}
                      className={"itemQuantityDrodown"}
                      onClick={() => {
                        this.props.payment.type = type;
                        // 👉 Set default machineType when selecting Card 1/2/3
                        if (type === "Card 1" || type === "Card 2" || type === "Card 3") {
                          if (!this.props.payment.machineType) {
                            this.props.payment.machineType = "credimax";
                          }
                        }

                        // Re-render after setting defaults
                        // this.setState({});
                      }}
                      // onClick={() => (this.props.payment.type = type)}
                    >
                      {type}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>

            </div>
            {this.props.payment.type !== "Short Paid" && this.props.payment.type !== "Store Credit" ? (
              <div className="othercashcard_payment">
                <div className="paymentcashcard_label">Enter Amount:</div>
                <input
                  style={{ background: "top" }}
                  min={0}
                  type="number"
                  id="card_amount"
                  name="card_amounts"
                  onChange={(e) => {
                    //  if(!localStorage.getItem("duplicate")){
                    this.props.payment.amount = e.target.value;
                    this.props.handleAmount(e);
                    this.setState({ amount: e.target.value });
                    //    }else{
                    //      notify.show("Change Payment Type","error")
                    //    }

                  }}
                  // defaultValue={this.props.payment.amount}
                  value={this.props.payment.amount}
                  placeholder="0"
                />
              </div>
            ) : (null)}
            {this.props.payment.type == "Short Paid" && (
              <div className="othercashcard_payment">
                <div className="paymentcashcard_label">Enter Amount Limit is 0.5:</div>
                <input
                  style={{ background: "top" }}
                  min="0"
                  type="number"
                  max="0.5"
                  step="0.1"
                  id="card_amount"
                  name="card_amounts"
                  onChange={(e) => {
                    if (e.target.value <= 0.5) {
                      this.props.payment.amount = e.target.value;
                      this.props.handleAmount(e);
                      this.setState({ amount: e.target.value });
                    } else {
                      e.target.value = 0
                    }

                  }}
                  // defaultValue={this.props.payment.amount}
                  value={this.props.payment.amount}
                  placeholder="0"
                />
              </div>
            )}
            {this.props.payment.type == "Store Credit" && (
              <div className="othercashcard_payment">
                <div className="paymentcashcard_label">Enter Amount:</div>
                <input
                  style={{ background: "top" }}
                  min="0"
                  type="number"
                  max={Number(storeCreditLimit)}
                  // step="0.1"
                  // id="card_amount"
                  // name="card_amounts"
                  onChange={(e) => {
                    if (e.target.value <= Number(storeCreditLimit)) {
                      this.props.payment.amount = e.target.value;
                      this.props.handleAmount(e, this.props.payment);
                      this.setState({ amount: e.target.value });
                    } else {
                      e.target.value = 0
                    }

                  }}
                  // defaultValue={this.props.payment.amount}
                  value={this.props.payment.amount}
                  placeholder="0"
                />
              </div>
            )}
            {this.props.payment.type === "Card 1" ? (
              <div className="othercashcard_payment">
                <div className="paymentcashcard_label">Transaction Id:</div>
                <input
                  style={{ background: "top" }}
                  id="trans_id"
                  name="trans_ids"
                  onChange={(e) => (this.props.payment.trnsId = e.target.value)}
                  defaultValue={this.props.payment.trnsId}
                />
              </div>
            ) : null}
            {this.props.payment.type === "Card 2" ? (
              <div className="othercashcard_payment">
                <div className="paymentcashcard_label">Transaction Id:</div>
                <input
                  style={{ background: "top" }}
                  id="trans_id2"
                  name="trans_ids"
                  onChange={(e) => (this.props.payment.trnsId = e.target.value)}
                  defaultValue={this.props.payment.trnsId}
                />
              </div>
            ) : null}
            {this.props.payment.type === "Card 3" ? (
              <div className="othercashcard_payment">
                <div className="paymentcashcard_label">Transaction Id:</div>
                <input
                  style={{ background: "top" }}
                  id="trans_id3"
                  name="trans_ids"
                  onChange={(e) => (this.props.payment.trnsId = e.target.value)}
                  defaultValue={this.props.payment.trnsId}
                />
              </div>
            ) : null}
            {this.props.payment.type == "Benefit Pay" && (
              <div className="othercashcard_payment">
                <div className="paymentcashcard_label">Transaction Id:</div>
                <input
                  style={{ background: "top" }}
                  id="trans_ide"
                  name="trans_ides"
                  onChange={(e) => (this.props.payment.trnsId = e.target.value)}
                  defaultValue={this.props.payment.trnsId}
                />
              </div>
            )}
            {this.props.payment.type == "Afs Cards" && (
              <div className="othercashcard_payment">
                <div className="paymentcashcard_label">Transaction Id:</div>
                <input
                  style={{ background: "top" }}
                  id="trans_id_afs"
                  name="trans_id_afs"
                  onChange={(e) => (this.props.payment.trnsId = e.target.value)}
                  defaultValue={this.props.payment.trnsId}
                />
              </div>
            )}
            {this.props.payment.type === "Card 1" || this.props.payment.type === "Card 2" || this.props.payment.type === "Card 3" ? (
              <React.Fragment>
                {machineTypeArray.length > 0 &&
                  <div className="othercashcard_payment">
                    <div className="paymentcashcard_label">Machine Type:</div>
                    <Dropdown
                      className="paymentTypeDropdownContainer"
                      isOpen={this.state.machineTypeToggle}
                      toggle={() =>
                        this.setState({
                          machineTypeToggle: !this.state.machineTypeToggle,
                        })
                      }
                    >
                      <DropdownToggle caret className="paymentTypeDropdown">
                        {this.props.payment.machineType == ""
                          ? "Select"
                          : machineTypeArray.find(item => item.key === this.props.payment.machineType).label}
                      </DropdownToggle>
                      <DropdownMenu className={'dropdownMenu'}>
                        {machineTypeArray.map((item, i) => (
                          <DropdownItem
                            key={i}
                            className={"itemQuantityDrodown"}
                            onClick={() => {
                              this.props.payment.machineType = item.key;
                              if (this.props.payment.cardType === "Amex" && item.key === "afs") {
                                //when AFS card is selected, Amex should be cleared / disabled for machine type
                                this.props.payment.cardType = "";
                              }
                            }}
                          >
                            {item.label}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                }
                <div className="othercashcard_payment">
                  <div className="paymentcashcard_label">Card Type:</div>
                  <Dropdown
                    className="paymentTypeDropdownContainer"
                    isOpen={this.state.cardTypeToggle}
                    toggle={() =>
                      this.setState({
                        cardTypeToggle: !this.state.cardTypeToggle,
                      })
                    }
                  >
                    <DropdownToggle caret className="paymentTypeDropdown">
                      {this.props.payment.cardType == ""
                        ? "Select"
                        : `${this.props.payment.cardType}`}
                    </DropdownToggle>
                    <DropdownMenu className={'dropdownMenu'}>
                      {this.cardTypes.map((cardType, i) => (
                        <DropdownItem
                          key={i}
                          className={"itemQuantityDrodown"}
                          onClick={() => (this.props.payment.cardType = cardType)}
                          disabled={(this.props.payment.machineType === "afs" && cardType === 'Amex') ? true : false}
                        >
                          {cardType}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </React.Fragment>
            ) : null}
          </div>
        </Col>
      </Row>
    );
  }
}

export default PaymentType;



// WEBPACK FOOTER //
// ./src/components/Intransit/Payment/PaymentType.js